
import { defineComponent, PropType } from 'vue'

import BaseAvatar from '@/components/BaseAvatar.vue'
import { VideoQuestionAttributes } from '@/types/models/video-question'
import { dayjs } from '@/plugins/dayjs'

export default defineComponent({
  props: {
    videoQuestion: {
      type: Object as PropType<VideoQuestionAttributes | undefined>,
      'default': () => (undefined),
    }
  },
  components: { BaseAvatar },
  setup() {
    const datetimeFormatter = (datetime: string) => dayjs(datetime).format('YYYY/MM/DD HH:mm:ss')

    return {
      datetimeFormatter
    }
  },
})
